import * as React from 'react';
export const IcSmileyHappy = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8.58 7.16a5.77 5.77 0 01-.78 1 .472.472 0 01-.06.09 5.617 5.617 0 01-.7.59 5.769 5.769 0 01-1.95.94h-.16a4.515 4.515 0 01-.53.11H11.12a4.515 4.515 0 01-.53-.11h-.16a5.769 5.769 0 01-1.95-.94 5.614 5.614 0 01-.7-.59.47.47 0 01-.06-.09 5.771 5.771 0 01-.78-1 1 1 0 111.67-1.06c.183.292.401.561.65.8.149.14.31.268.48.38l.1.07a4.14 4.14 0 004.32 0l.1-.07c.17-.112.332-.24.48-.38a4.21 4.21 0 00.65-.8 1 1 0 111.69 1.06z'
      fill='currentColor'
    />
  </svg>
);
